export default __webpack_public_path__ + "static/media/info-circle.159f6f25.svg";